import { SalesOrderDeliveryType } from '../../../constants/sales-order-delivery-type/index.js';
/** Why `field` can't hold a value on an order of this type, or null when it can. */
export function deliveryAssigneeMismatchMessage(deliveryTypeId, field) {
    if (deliveryTypeId === SalesOrderDeliveryType.EXTERNAL) {
        return field === 'deliveryDriverUserId' ? "External Delivery doesn't take a driver." : null;
    }
    if (deliveryTypeId === SalesOrderDeliveryType.INTERNAL) {
        return field === 'deliveryDriverUserId' ? null : "Internal Delivery doesn't take a carrier.";
    }
    return "Pick Up doesn't take a carrier.";
}
//# sourceMappingURL=delivery-assignee-mismatch-message.js.map